import ExternalPage from './ExternalPage'
import NurseryHeader from './NurseryHeader'
import PoweredByBlossomFooter from './PoweredByBlossomFooter'

ExternalPage.NurseryHeader = NurseryHeader
ExternalPage.PoweredByBlossomFooter = PoweredByBlossomFooter

export default ExternalPage
